import { render, staticRenderFns } from "./StockAvailabilityTable.vue?vue&type=template&id=1f4c1ed2"
import script from "./StockAvailabilityTable.vue?vue&type=script&lang=ts"
export * from "./StockAvailabilityTable.vue?vue&type=script&lang=ts"
import style0 from "./StockAvailabilityTable.vue?vue&type=style&index=0&id=1f4c1ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports